import { useMemo } from 'react';
import { ISocialAccount } from '@components';

export interface BrandMentionsProps {
  isLoading: boolean;
  brands: Array<{
    name: string;
    logo_url: string;
    username: string;
    mention_count: number;
  }>;
  hasData: boolean;
}

export const useBrandMentionsProps = (
  isFetchingSocialData: boolean,
  socialData: ISocialAccount | null
): BrandMentionsProps => {
  return useMemo(() => {
    const isLoading = isFetchingSocialData;

    const brands = socialData?.report?.top_brands || [];
    const hasData = brands.length > 0;

    return {
      isLoading,
      brands,
      hasData,
    };
  }, [isFetchingSocialData, socialData]);
};
